import DailyLimits from '@/models/loyaltyPanel/stores/DailyLimits';
const getDefaultState = () => ({
    dailyLimits: [],
    dailyLimit: new DailyLimits(),
    updateDialog: false,
  });

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setItems(state, payload) {
      state.dailyLimits = payload;
    },

    setItem(state, payload) {
      state.dailyLimit = new DailyLimits(payload);
    },

    setDialog(state, payload) {
      state.updateDialog = payload;
    },
  },

  actions: {
    async getItems({ commit }, query) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await DailyLimits.getDailyLimits(query);

        const { default_values, pagination } = data.data;

        commit('setItems', default_values[0].stores);
        commit('setItem', default_values[0].daily_limits);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data.message);
      }
    },

    async updateLimit({ commit }, dailyLimit) {
      try {
        commit('setLoading', true, { root: true });
        const store_id = dailyLimit.store_id;
        delete dailyLimit.app_name;
        delete dailyLimit.store_id;
        await DailyLimits.updateDailyLimit(dailyLimit, store_id);

        commit('setDialog', false);
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated Transaction limit!',
          },

          { root: true }
        );
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data.message);
      }
    },

    async updateGlobalLimits({ commit, dispatch }, data) {
      try {
        commit('setLoading', true, { root: true });
        delete data.app_name;
        delete data.store_id;
        await DailyLimits.updateGlobalDailyLimits(data);

        commit('setDialog', false);
        dispatch('getItems', '?page=1');
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated Transaction limit!',
          },

          { root: true }
        );
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data.message);
      }
    },
  },
};
